/**
 * This service manages all of teh navigation
 */

export default function AlertsNavService(gettext) {
  'ngInject';

  let module = {
    id: 'alerts',
    name: gettext('Alerts'),
    sref: 'alerts',
    icon: 'fas fa-exclamation-circle',
    priority: 70,
    items: [
      {
        name: gettext('Dashboard'),
        sref: 'alerts.dashboard',
        group: 'alerts'
      },
      {
        name: gettext('Historical Alerts'),
        mobileName: gettext('View Historical Alerts'),
        sref: 'alerts.history',
        group: 'alerts'
      },
      {
        name: gettext('Alert Configurations'),
        mobileName: gettext('Alert Configurations'),
        sref: 'alerts.configurations.list',
        group: 'configuration'
      },
      {
        name: gettext('Create Alert Configuration'),
        sref: 'alerts.configurations.create',
        group: 'configuration'
      },
      {
        name: gettext('Fault Configurations'),
        mobileName: gettext('Fault Configurations'),
        sref: 'alerts.faults.list',
        group: 'configuration'
      },
      {
        name: gettext('Create Fault Configuration'),
        sref: 'alerts.faults.create',
        group: 'configuration'
      },
      {
        name: gettext('GeoZone Configurations'),
        mobileName: gettext('GeoZone Configurations'),
        sref: 'alerts.geozone.list',
        group: 'geozones'
      },
      {
        name: gettext('Create GeoZone Configuration'),
        sref: 'alerts.geozone.create',
        group: 'geozones'
      }
    ],
    groups: [
      {
        id: 'alerts',
        name: gettext('Alerts')
      },
      {
        id: 'configuration',
        name: gettext('Configurations')
      },
      {
        id: 'geozones',
        name: gettext('GeoZones')
      }
    ]
  };

  this.getModule = function () {
    return module;
  };
}
